<template>
  <div class="animated fadeIn pb4 py3">
    <div class="clearfix gibson px3 mb2">
      <!-- mobile view -->
      <div class="col-12 px0" v-if="showMobile">
        <div class="clearfix border muted-border p2 py3 shadow">
          <div class="col-12 gibson">
            <p class="h4 semi-bold line-height-2 my2 darkblue">Indhent anbefalinger</p>
            <div class="flex flex-column justify-start items-center mb3">
              <div class="col-12 flex flex-column justify-center items-center px3 mt3">
                <b-img src="static/svg/hired.svg" width="64" height="64"></b-img>
                <p class="h5 semi-bold darkblue gibson line-height-1 my2">
                  Få anbefalinger
                </p>
              </div>
              <div class="col-12 flex flex-column justify-center items-center px3 mt3">
                <b-img src="static/svg/files.svg" width="64" height="64"></b-img>
                <p class="h5 semi-bold darkblue gibson line-height-1 my2">
                  Skil dig ud og bliv set
                </p>
              </div>
              <div class="col-12 flex flex-column justify-center items-center px3 mt3">
                <b-img src="static/svg/target.svg" width="64" height="64"></b-img>
                <p class="h5 semi-bold darkblue gibson line-height-1 my2">
                  Få flere kunder
                </p>
              </div>
            </div>
            <p class="h5 regular darkblue line-height-golden mb2">
              Gode anbefalinger fra dine tidligere kunder er nøglen til at få flere nye kunder.
            </p>
            <p class="h5 regular darkblue line-height-golden mb2">
              Håndværker.dk gør det nu muligt for dig at hente anbefalinger fra kunder, som du har løst opgaver for uden om vores system. Alt du skal gøre er at indtaste din kundes navn og e-mailadresse eller telefonnummer og klikke på ‘Send’-knappen
            </p>
            <p class="h5 regular darkblue line-height-golden mb3">
              Der er ikke begrænsning på antallet af kunder, som du kan sende til.
            </p>
            <haandvaerker></haandvaerker>
            <b-form class="collectReviewForm" @submit.stop.prevent="service_jule_action">
              <div class="py-2"></div>
              <b-form-row v-for="(customer, index) in customers" :key="index">
                <b-col sm="12" md="12" lg="3">
                  <b-form-group  label="Navn" >
                    <b-form-input  type="text"  v-model="customer.name" name="customers[][name]" required class="muted-background gibson darkblue p2 border-blue not-rounded h5"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="12" lg="3">
                  <b-form-group label="E-mail" >
                    <b-form-input  type="email"  v-model="customer.email" name="customers[][email]"  class="muted-background gibson darkblue p2 border-blue not-rounded h5"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="12" lg="3">
                  <b-form-group label="Mobil" >
                    <b-form-input  type="tel"  v-model="customer.mobile" name="customers[][mobile]"  class="muted-background gibson darkblue p2 border-blue not-rounded h5"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="12" lg="2">
                  <div class="py-3"></div>
                  <b-button size="sm" class="rounded" @click="delCustomer(index)" variant="outline-danger"  v-if="index !== 0">
                    <span class="far fa-trash-alt"></span>
                  </b-button>
                  <b-button size="sm" class="rounded ml-2" @click="addCustomer()" variant="outline-success" >
                    <span class="el-icon-circle-plus"></span>
                  </b-button>
                  <div class="py-2"></div>
                </b-col>
              </b-form-row>

              <div class="py-3"></div>
              <b-col  sm="12" md="12" lg="8">
                <div class="d-flex justify-content-center">
                  <b-btn size="lg" type="submit" class="rounded flex justify-center items-center" variant="success">
                    <span class="mr2 white inline-block flex justify-center items-center"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevrons-circle-right-f"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z' /></svg></span> Send
                  </b-btn>
                </div>
              </b-col>
            </b-form>
          </div>
        </div>
        <div class="py4"></div>
      </div>
      <!-- desktop view -->
      <div class="clearfix px0 mb4 ml4" v-if="!showMobile && !showXXL">
        <div class="flex flex-column p2 py3 gibson">
          <div class="col-5">
            <p class="h4 semi-bold line-height-2 my2 darkblue">Indhent anbefalinger</p>
            <p class="h5 regular darkblue line-height-golden mb3">
              Vi oplever at anbefalinger af håndværkernes udførte arbejde i stigende grad spiller en rolle, når bygherre skal vælge håndværkere.
            </p>
          </div>
          <div class="col-7 flex justify-start items-center mb3">
            <div class="flex flex-column justify-center items-center px3">
              <p class="h5 semi-bold darkblue gibson line-height-1 mb2">
                Få anbefalinger
              </p>
              <b-img src="static/svg/hired.svg" width="64" height="64"></b-img>
            </div>
            <div class="flex flex-column justify-center items-center px3 primarycolor">
              <p class="h5 semi-bold darkblue gibson line-height-1 mb2">
                Skil dig ud og bliv set
              </p>
              <b-img src="static/svg/files.svg" width="64" height="64"></b-img>
            </div>
            <div class="flex flex-column justify-center items-center px3">
              <p class="h5 semi-bold darkblue gibson line-height-1 mb2">
                Få flere kunder
              </p>
              <b-img src="static/svg/target.svg" width="64" height="64"></b-img>
            </div>
          </div>
          <div class="col-5">
            <p class="h5 regular darkblue line-height-golden mb3">
              Håndværker.dk gør det nu muligt for dig at øge dine chancer for succes ved at lade dine kunder, som du har løst opgaver for uden om vores system, anbefale dit arbejde. Alt du skal gøre er at indtaste din kundes navn og e-mailadresse og klikke på linket.
            </p>
            <p class="h5 regular darkblue line-height-golden mb3">
              Der er ikke begrænsning på antallet af kunder, som du kan sende til.
            </p>
          </div>
          <div class="col-8">
            <haandvaerker></haandvaerker>
            <b-form class="collectReviewForm" @submit.stop.prevent="service_jule_action">
              <div class="py-2"></div>
              <b-form-row v-for="(customer, index) in customers" :key="index">
                <b-col sm="12" md="12" lg="3">
                  <b-form-group  label="Navn" >
                    <b-form-input  type="text"  v-model="customer.name" name="customers[][name]" required class="muted-background gibson darkblue p2 border-blue not-rounded h5"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="12" lg="3">
                  <b-form-group label="E-mail" >
                    <b-form-input  type="email"  v-model="customer.email" name="customers[][email]"  class="muted-background gibson darkblue p2 border-blue not-rounded h5"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="12" lg="3">
                  <b-form-group label="Mobil" >
                    <b-form-input  type="tel"  v-model="customer.mobile" name="customers[][mobile]"  class="muted-background gibson darkblue p2 border-blue not-rounded h5"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="12" lg="2">
                  <div class="py-3"></div>
                  <b-button size="sm" class="rounded" @click="delCustomer(index)" variant="outline-danger"  v-if="index !== 0">
                    <span class="far fa-trash-alt"></span>
                  </b-button>
                  <b-button size="sm" class="rounded ml-2" @click="addCustomer()" variant="outline-success" >
                    <span class="el-icon-circle-plus"></span>
                  </b-button>
                  <div class="py-2"></div>
                </b-col>
              </b-form-row>
              <div class="py-3"></div>
              <b-col  sm="12" md="12" lg="8">
                <div class="d-flex justify-content-center">
                  <b-btn size="lg" type="submit" class="rounded flex justify-center items-center" variant="success">
                    <span class="mr2 inline-block flex justify-center items-center white"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevrons-circle-right-f"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z' /></svg></span> Send
                  </b-btn>
                </div>
              </b-col>
            </b-form>
          </div>
        </div>
      </div>
      <!-- XXL view -->
      <div class="clearfix px0 mb4 ml4" v-if="showXXL">
        <div class="flex flex-column p2 py3 gibson">
          <div class="col-12">
            <p class="h4 semi-bold line-height-2 my2 darkblue">Indhent anbefalinger</p>
            <p class="h5 regular darkblue line-height-golden mb3 pb2">
              Vi oplever at anbefalinger af håndværkernes udførte arbejde i stigende grad spiller en rolle, når bygherre skal vælge håndværkere.
            </p>
          </div>
          <div class="col-12 flex justify-start justify-around items-center mb3">
            <div class="flex flex-column justify-center items-center px6">
              <p class="h5 semi-bold darkblue gibson line-height-1 mb2">
                Få anbefalinger
              </p>
              <b-img src="static/svg/hired.svg" width="64" height="64"></b-img>
            </div>
            <div class="flex flex-column justify-center items-center px6 primarycolor">
              <p class="h5 semi-bold darkblue gibson line-height-1 mb2">
                Skil dig ud og bliv set
              </p>
              <b-img src="static/svg/files.svg" width="64" height="64"></b-img>
            </div>
            <div class="flex flex-column justify-center items-center px6">
              <p class="h5 semi-bold darkblue gibson line-height-1 mb2">
                Få flere kunder
              </p>
              <b-img src="static/svg/target.svg" width="64" height="64"></b-img>
            </div>
          </div>
          <div class="col-12">
            <p class="h5 regular darkblue line-height-golden mb3 pt2">
              Håndværker.dk gør det nu muligt for dig at øge dine chancer for succes ved at lade dine kunder, som du har løst opgaver for uden om vores system, anbefale dit arbejde. Alt du skal gøre er at indtaste din kundes navn og e-mailadresse og klikke på linket.
            </p>
            <p class="h5 regular darkblue line-height-golden mb3">
              Der er ikke begrænsning på antallet af kunder, som du kan sende til.
            </p>
          </div>
          <div class=" col-12 center">
            <haandvaerker></haandvaerker>
            <b-form class="collectReviewForm" @submit.stop.prevent="service_jule_action">
              <div class="py-2"></div>
              <b-form-row v-for="(customer, index) in customers" :key="index">
                <b-col sm="12" md="12" lg="4">
                  <b-form-group  label="Navn" >
                    <b-form-input  type="text"  v-model="customer.name" name="customers[][name]" required class="muted-background gibson darkblue p2 border-blue not-rounded h5"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="12" lg="4">
                  <b-form-group label="E-mail" >
                    <b-form-input  type="email"  v-model="customer.email" name="customers[][email]"  class="muted-background gibson darkblue p2 border-blue not-rounded h5"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="12" lg="3">
                  <b-form-group label="Mobil" >
                    <b-form-input  type="tel"  v-model="customer.mobile" name="customers[][mobile]"  class="muted-background gibson darkblue p2 border-blue not-rounded h5"></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col sm="12" md="12" lg="1">
                  <div class="py-3"></div>
                  <b-button size="sm" class="rounded" @click="delCustomer(index)" variant="outline-danger"  v-if="index !== 0">
                    <span class="far fa-trash-alt"></span>
                  </b-button>
                  <b-button size="sm" class="rounded ml-2" @click="addCustomer()" variant="outline-success" >
                    <span class="el-icon-circle-plus"></span>
                  </b-button>
                  <div class="py-2"></div>
                </b-col>
              </b-form-row>

              <div class="justify-around py-3"></div>
              <b-col  sm="12" md="12" lg="12">
                <div class="d-flex justify-content-center">
                  <b-btn size="lg" type="submit" class="rounded flex justify-center items-center" variant="success">
                    <span class="white mr2 inline-block flex justify-center items-center"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevrons-circle-right-f"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z' /></svg></span> Send
                  </b-btn>
                </div>
              </b-col>

            </b-form>
          </div>
        </div>
      </div>
      <loading :show="show" :label="label" :overlay="overlay"></loading>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </div>
  </div>
</template>
<script>
  import Simplert from 'vue2-simplert'
  import loading from 'vue-full-loading'
  import Haandvaerker from './haandvaerker'
  import Vue from 'vue'
  export default {
    name: 'jule',
    components: {
      loading,
      Haandvaerker,
      Simplert,
      Vue
    },
    data () {
      return {
        selected: '',
        salesPerson: '',
        imgPicked: '',
        consent: '0',
        show: false,
        label: 'Loading...',
        overlay: 1,
        modalShowMail: false,
        isLoadingMail: false,
        items: [],
        images: [],
        textReason: '',
        url: '',
        startend: '',
        finishend: '',
        imageSelect: '',
        message: '',
        haaCredit: false,
        showMobile: false,
        showXXL: false,
        opsige: false,
        Canexpire: true,
        showimentor: true,
        opsigedone: false,
        showDismissibleAlert: false,
        customer: {
          name: '',
          email: '',
          mobile: ''
        },
        customers: []
      }
    },
    methods: {
      Reload () {
        if (screen.width <= 640) {
          this.showMobile = true
        } else {
          this.showMobile = false
        }
        if (screen.width >= 1000) {
          this.showXXL = true
        } else {
          this.showXXL = false
        }
        this.show = true
        this.salesPerson = localStorage.getItem('id_token_portal')
        this.haaId = localStorage.getItem('haaid')
        var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId}
        this.$http.post('', data, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              this.show = false
              if (res.login === false) {
                this.$router.push('/login')
              }
              this.items = res
              this.images = res.resultImages
              if (this.images.length !== 0) {
                this.imgPicked = this.images[0].FileLocation
              }
            },
            response => {
              alert('error')
            }
          )
      },
      service_jule_action () {
        this.show = true
        this.salesPerson = localStorage.getItem('id_token_portal')
        this.haaId = localStorage.getItem('haaid')
        var data = {operation: 'service_invite_action', salesPerson: this.salesPerson, levid: this.haaId, customers: JSON.stringify(this.customers), imgPicked: this.imgPicked, bcc: this.consent}
        this.$http.post('', data, { emulateJSON: true })
          .then(
            response => {
              var res = response.body
              this.show = false
              if (res.login === false) {
                this.$router.push('/login')
              }
              if (res.success) {
                this.modalShowDato = false
                let obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success'
                }
                this.customers = []
                this.customers.push(Vue.util.extend({}, this.customer))
                this.$refs.simplert.openSimplert(obj)
              } else {
                alert(res.message)
              }
            },
            response => {
              alert('error')
            }
          )
      },
      addCustomer () {
        this.customers.push(Vue.util.extend({}, this.customer))
      },
      delCustomer (index) {
        Vue.delete(this.customers, index)
      }
    },
    created () {
      this.customers.push(Vue.util.extend({}, this.customer))
      this.Reload()
    }
  }
</script>



// WEBPACK FOOTER //
// IndhentAnbefalinger.vue?41c0b79f